import { render } from "./equipos_tipos_especialidades.vue?vue&type=template&id=c5d0d7c6"
import script from "./equipos_tipos_especialidades.vue?vue&type=script&lang=js"
export * from "./equipos_tipos_especialidades.vue?vue&type=script&lang=js"

import "./equipos_tipos_especialidades.vue?vue&type=style&index=0&id=c5d0d7c6&lang=css"

import exportComponent from "/src/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__